import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PlatformBrowserService } from '@app/core/services/platform-browser.service';

@Component({
    selector: 'app-wiki',
    templateUrl: './wiki.component.html',
    styleUrls: ['./wiki.component.scss']
})
export class WikiComponent {
    public hideHeaderAndFooter: boolean = false;

    public constructor(private browserService: PlatformBrowserService, private activatedRoute: ActivatedRoute) {
        this.verifyParams();
    }

    public onActivate(): void {
        if (!this.browserService.isBrowser) {
            return;
        }

        window.scroll(0, 0);
    }

    private verifyParams(): void {
        this.activatedRoute.queryParams.subscribe((params: any) => {
            if (params.hide === 'true') {
                this.hideHeaderAndFooter = true;

                return;
            }
            this.hideHeaderAndFooter = false;
        });
    }
}
